/**
 * useImageChanges - Tracks which assets and channels have unsaved changes.
 */

import { useState, useCallback } from 'react';

export function useImageChanges() {
  const [changedAssetIds, setChangedAssetIds] = useState<Set<string>>(new Set());
  const [changedChannelKeys, setChangedChannelKeys] = useState<Set<string>>(new Set());

  const clearChanges = useCallback(() => {
    setChangedAssetIds(new Set());
    setChangedChannelKeys(new Set());
  }, []);

  return {
    changedAssetIds,
    setChangedAssetIds,
    changedChannelKeys,
    setChangedChannelKeys,
    clearChanges,
  };
}
